/* eslint-disable max-len */
const CannotRenderFile: React.FC = () => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30.3333 25.3334H33.6667V22H30.3333V25.3334ZM30.3333 8.66671V18.6667H33.6667V8.66671M7.00001 23.6667H15.3333V27H7.00001M7.00001 17H20.3333V20.3334H7.00001M3.66668 0.333374C1.81668 0.333374 0.333344 1.81671 0.333344 3.66671V30.3334C0.333344 32.1834 1.81668 33.6667 3.66668 33.6667H23.6667C25.5167 33.6667 27 32.1834 27 30.3334V10.3334L17 0.333374M3.66668 3.66671H15.3333V12H23.6667V30.3334H3.66668V3.66671Z" fill="#868E96"/>
  </svg>
);

export default CannotRenderFile;
